import { Address } from '@lyrahealth-inc/shared-app-logic/src/models/providers/Providers'
import { MEETING_FORMATS } from '@lyrahealth-inc/shared-app-logic/src/models/session/Session'

import { meetingFormatChargeModalityMap } from '../../common/constants/appConstants'

/**
 * Returns modality information for no-show/late cancel transfers.
 * Returns a JSON-stringified object that will be parsed by getBCCharge.
 * For EngageDA providers, modality is sent as a JSON string containing type and optional location data.
 */
export const getNoShowLateCancelModality = (
  meetingFormat: string,
  providerAddresses: Address[] | null | undefined,
): string => {
  const mappedModality = meetingFormatChargeModalityMap[meetingFormat as keyof typeof meetingFormatChargeModalityMap]

  if (!mappedModality) {
    throw new Error(`Unsupported meeting format for modality mapping: ${meetingFormat}`)
  }

  const modality: { type: string; state?: string; zipcode?: string } = {
    type: mappedModality as string,
  }

  const state = providerAddresses?.[0]?.state
  const zipcode = providerAddresses?.[0]?.zipcode

  if (meetingFormat === MEETING_FORMATS.IN_PERSON && state && zipcode) {
    modality.state = state
    modality.zipcode = zipcode
  }

  return JSON.stringify(modality)
}
